import { useRef } from 'react';

/* Shared card shell — premium white surface, soft ring, hover lift,
   and a mouse-tracked spotlight sheen for that modern feel */
export default function Card({ children, className = '', delay = 0 }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    ref.current.style.setProperty('--x', `${e.clientX - r.left}px`);
    ref.current.style.setProperty('--y', `${e.clientY - r.top}px`);
  };

  return (
    <section
      ref={ref}
      onMouseMove={onMove}
      className={`spotlight bg-white rounded-2xl border border-slate-200/70 ring-1 ring-transparent shadow-card transition-all duration-300 hover:shadow-lift hover:ring-slate-200/60 animate-fade-up ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </section>
  );
}
